import { useContext, useState } from "react";
import styles from "../styles/Navbar.module.css";
import { Link } from "react-router-dom";
import { UserContext } from "./context/user/UserContext";

const Navbar = () => {
  const { userData, logout, isLoading } = useContext(UserContext);
  const [id, setId] = useState(false);
  function showMenu() {
    setId(!id);
  }

  return (
    <nav className={styles.container}>
      {/* Logo and Brand */}
      <Link to="/" className={styles.logo}>
        <img
          src={require("../assets/logo.png")}
          alt="RigRest'r Logo"
          width="60"
          height="60"
        />
        <div className={styles.brandName}>
          <span>RIG REST'R</span>
        </div>
      </Link>

      {/* Navigation Menu */}
      <div className={`${styles.nav} ${id ? styles.active : ''}`}>
        <ul className={styles.list}>
          {!isLoading && userData?.user?.isAdmin && (
            <Link to="/admin">
              <li className={styles.listItem}>📊 Dashboard</li>
            </Link>
          )}
          {!isLoading &&
            userData?.user?.isManager &&
            !userData?.user?.isAdmin && (
              <Link to="/AddSighting">
                <li className={styles.listItem}>📍 Add Location</li>
              </Link>
            )}
          <Link to="/about">
            <li className={`${styles.listItem} ${styles.boldItem}`}>About Us</li>
          </Link>
          <Link to="/terms">
            <li className={`${styles.listItem} ${styles.boldItem}`}>Terms</li>
          </Link>
          {!isLoading && !userData && (
            <>
              <Link to="/login">
                <li className={styles.login}>Login</li>
              </Link>
              <Link to="/signup">
                <li className={styles.signup}>Sign Up</li>
              </Link>
            </>
          )}
          {!isLoading && userData && (
            <>
              <Link to="/account">
                <li className={styles.listItem}>⚙️ Account</li>
              </Link>
              <button onClick={() => logout()} className={styles.logoutBtn}>
                <li className={styles.logout}>Logout</li>
              </button>
            </>
          )}
        </ul>
      </div>

      {/* Hamburger Menu Button */}
      <div className={styles.menuBtn} id={id ? "showMenu" : ""}>
        <button onClick={showMenu} aria-label="Toggle menu">
          <div className={styles.hamburger}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
